(ns app.front.view.group.admin.config.notifications
  (:require [app.domain.licence.model :as licence-model]
            [app.domain.workspace-notification.model :as workspace-notification-model]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::show-editor?
  ;; there may be another filter elsewhere, but this is making sure that we don't show this UI
  ;; at levels which are not supported by the shared code
  (fn [[_ group-config-id]]
    (rf/subscribe [::gas/group-config-level group-config-id]))
  (fn [level]
    (contains? workspace-notification-model/supported-levels level)))

(defn- edit-notification-config
  [{:keys [*group-config tr group-id]}
   index
   {:workspace-notification-config/keys [type interval]}
   attr]
  [ui/number-input {:id         (str group-id "-" (name type))
                    :label-text (tr [type])
                    :value      interval
                    ;; this is licence-specific, because for now, pre-con expiration is not read-only
                    :disabled   (and (licence-model/read-only-type? type)
                                     ;; allow changing interval if different from the read-only default value
                                     (->> licence-model/default-notification-configs
                                          (filter #(-> % :workspace-notification-config/type (= type)))
                                          first
                                          :workspace-notification-config/interval
                                          (= interval)))
                    :on-change  (fn [val]
                                  (let [interval   (some-> val futil/tval futil/parse-int)
                                        new-config {:workspace-notification-config/type     type
                                                    :workspace-notification-config/interval interval}]
                                    (swap! *group-config update attr
                                           (fn [nconfigs]
                                             ;; Are we updating an existing notification config for this
                                             ;; group config or creating a new one?
                                             (->> (if index
                                                    (update nconfigs index merge new-config)
                                                    (conj nconfigs new-config))
                                                  (filterv (comp some? :workspace-notification-config/interval)))))))}])

(defn descending? [coll]
  (or (-> coll rest seq not)
      (->> coll
           rest
           (reduce (fn [[prev _] curr]
                     (if (< curr prev)
                       [curr true]
                       (reduced [nil false])))
                   [(first coll) true])
           last)))

(defn- values-descending? [nconfigs]
  (->> nconfigs
       (sort-by (fn [{:workspace-notification-config/keys [type]}]
                  (p/find-index workspace-notification-model/workspace-notification-types
                                (partial = type))))
       (map :workspace-notification-config/interval)
       descending?))

(defn editor
  [{:keys [title attr types]} {:keys [*group-config parent-config target tr] :as ctx}]
  (when (<sub [::show-editor? target])
    (let [[_ parent-val]      (->> parent-config
                                   attr
                                   (filter val)
                                   first)
          parent-vals-by-type (->> parent-val
                                   (map #(dissoc % :db/id))
                                   (map (juxt :workspace-notification-config/type identity))
                                   (into {}))
          values              (not-empty (get @*group-config attr))
          type->idx           (->> values
                                   (map-indexed (fn [index nconfig]
                                                  [(:workspace-notification-config/type nconfig) index]))
                                   (into {}))]
      [:<>
       (when-not (values-descending? values)
         [ui/warning (tr [:group-admin/ascending-configs-error])])
       (cc/form-group
         {:legend-text title}
         (futil/for-frag [notification-type types]
           (let [index   (type->idx notification-type)
                 nconfig (or
                           ;; Either this config already specifies this notification type
                           (and index (nth values index))
                           ;; or the parent does
                           (parent-vals-by-type notification-type)
                           ;; or no one
                           {:workspace-notification-config/type     notification-type
                            :workspace-notification-config/interval nil})]
             [edit-notification-config ctx index nconfig attr])))])))

(defn config->values
  [attr config]
  (or (some->> config
               attr
               (mapv #(select-keys % [:db/id
                                      :workspace-notification-config/type
                                      :workspace-notification-config/interval])))
      []))

(defn valid-configs? [attr group-config]
  (let [nconfigs (get group-config attr)]
    (and
      (->> nconfigs
           (map :workspace-notification-config/type)
           (every? keyword?))
      (->> nconfigs
           (map :workspace-notification-config/interval)
           (every? licence-model/valid-interval?))
      (->> nconfigs
           (map :workspace-notification-config/interval)
           distinct
           count
           (= (count nconfigs)))
      (values-descending? nconfigs))))
